import {
  UPDATE_PHONE_ID,
  UPDATE_PRESALE_FLAG,
  FETCH_CUSTOMER,
  SWAP_LANGUAGE,
  FETCH_OPTIONS,
  CLEAR_CONTENT,
} from './constants'

export const updatePhoneId = (phoneId, deviceName) => {
  return {
    type: UPDATE_PHONE_ID,
    deviceName: deviceName,
    phoneId
  }
}

export const fetchCustomer = {
  request: custOverride => ({ type: FETCH_CUSTOMER['REQUEST'], custOverride }),
  success: customer => ({ type: FETCH_CUSTOMER['SUCCESS'], customer })
}

export const updatePresaleFlag = () => ({ type: UPDATE_PRESALE_FLAG })
export const swapLanguage = language => ({ type: SWAP_LANGUAGE, language })

export const fetchOptions = {
  request: customer => ({ type: FETCH_OPTIONS['REQUEST'], customer }),
  success: options => ({ type: FETCH_OPTIONS['SUCCESS'], options })
}

export const clearContent = () => ({ type: CLEAR_CONTENT })



// WEBPACK FOOTER //
// ./src/containers/App/actions.js